
export default {
  path:'/security',
  redirect: {name:'security'},
  component:() => import('@/pages/s'),
  children:[
    // 账号设置
    {
      path:'index',
      name:'security',
      component:() => import('@/pages/security/index')
    },
    //银行卡管理
    {
      path:'bankCard',
      name:'bankCard',
      component:() => import('@/pages/security/bankCard')
    },
  ]
}